import i18n from "../../i18n";
export function getResourceImageType() {
    return Object.freeze({
        Products: {
            key: 0,
            value: "Products",
            label: i18n.t('product.products')
        },
        Equipment: {
            key: 1,
            value: "Equipment",
            label: i18n.t('resource-manager.equipment')
        },
        Brands: {
            key: 2,
            value: "Brands",
            label: i18n.t('resource-manager.brands')
        }
    })
}